export default __webpack_public_path__ + "static/media/Curing-the-Disease-Nate-Baldwin.de24c109.jpg";